module.exports = "https://de18y2hs3hlxs.cloudfront.net/d7023bab-6786-4218-a639-f7331314cecc/images/doctors.png?f2c36e418b5725f34aa32f105b6d7e41";